import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull, formatDateTime, formatBalance } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

import MyBalancePanel from './Components/MyBalancePanel';
import PaymentDetailPanel from './Components/PaymentDetailPanel';

import IconContainer from '../IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';
import { ReactComponent as CopyIcon } from '../../icons/copy.svg';

const AMMembershipFees = ({ userId, userRole, isFromAccount }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);

  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const [limitForView, setLimitForView] = React.useState(50);

  React.useEffect(() => {
    if (!userId) return openTimeModal('Произошла ошибка системы. Попробуйте обновить страницу', 'error');
    const token = localStorage.getItem('token');
    
    setLoading(true);

    axios.get(`/api/get-user-balance-transactions?id=${userId}&limitForView=${limitForView}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);


  return (
    <>
        <div className='horizontalContainer'>
          <MyBalancePanel userId={userId} userRole={userRole} isFromAccount={isFromAccount} reload={reload} setReload={setReload} />
          <PaymentDetailPanel />
        </div>

        <div style={{height: '20px'}}></div>

        <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
            <h3>История операций</h3>
            <a className='lastUpdateWrapper'>
                {loading ? 
                    <Loading type='inline' /> 
                : 
                    <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                }
            </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '10fr 10fr 20fr 50fr 10fr' }}>
              <div>Сумма</div>
              <div>Действие</div>
              <div>Кем произведена</div>
              <div>Описание операции / Идентификатор</div>
              <div>Дата</div>
              <div></div>
          </div>
        </div>
        {(!cases && loading) ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} buttonText='Обновить' buttonAction={() => setReload(true)} inTable={true} />
        : cases.map((caseItem) => (
            <div 
              className='tableRow nonActive' 
              style={{ gridTemplateColumns: '10fr 10fr 20fr 50fr 10fr' }}
              key={caseItem.id} 
            >
              <div>{formatNull(caseItem.action)}{formatNull(formatBalance(caseItem.amount)) + ' ₽'}</div>
              <div>
                <p>
                  {caseItem.action=='+' && 'Пополнение'}
                  {caseItem.action=='-' && 'Списание'}
                </p>
                <p className='description'>
                  {caseItem.balance_type=='balance' && 'Членские взносы'}
                  {caseItem.balance_type=='specialBalance' && 'Целевые взносы'}
                </p>
              </div>
              <div>{caseItem.userDetails?.lastname} {caseItem.userDetails?.firstname} {caseItem.userDetails?.surname} {userRole==='АппаратСРО' && caseItem.userDetails?.email}</div>
              <div>
                <p>{formatNull(caseItem.description)}</p>
                <span className='horizontalLine'></span>
                <span style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                <p className='description'>Идентификатор транзакции: {formatNull(caseItem.transaction_id)}</p>
                  <IconContainer 
                      Icon={CopyIcon} 
                      label={'Скопировать'} 
                      onClick={() => {
                          navigator.clipboard.writeText(caseItem.transaction_id);
                          openTimeModal('Идентификатор скопирован', 'success');
                      }} 
                      size = '15' 
                      color = 'black' 
                      className = '' 
                  />
                </span>
              </div>
              <div className='monoTime'>{formatNull(formatDateTime(caseItem.created_at))}</div>
            </div>
        ))}
        {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
            <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div></div>
                <div>
                    <button
                        type='button'
                        className='button'
                        style={{ width: 'fit-content' }}
                        onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                        disabled={loading}
                    >
                        {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                    </button>
                </div>
                <div></div>
            </div>
        )}
      </div>
    </>
  )
}

export default AMMembershipFees;